module.exports = __webpack_public_path__ + "static/service-icon6-8f72924c95581bccfeb524f8acf5d534.png";